import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components';
import { EditIcon } from '~/icons';
import { SmallTrashIcon } from '~/icons/Trash';
import { colors } from '~/styles/colors';
import { Exception } from '../../types';
import { DamExceptionCardContainer } from './styles';

interface DamExceptionViewCardProps {
  exception: Exception;
  onDelete: () => void;
  onEdit: () => void;
  hide?: {
    edit: boolean;
    delete: boolean;
  }
  loading?: boolean;
}

export function DamExceptionViewCard({
  exception,
  hide,
  loading,
  onDelete,
  onEdit,
}: Readonly<DamExceptionViewCardProps>): ReactElement {
  const {
    beginTime, title, endTime, status, date,
  } = exception;
  const { t } = useTranslation();

  return (
    <DamExceptionCardContainer status={status} size="small">
      <div
        style={{
          marginLeft: '17px',
          marginTop: '5px',
          fontSize: '12px',
          width: '151px',
          fontWeight: 'bold',
        }}
      >
        {title}
      </div>
      <div
        style={{
          marginLeft: '74px',
          marginTop: '5px',
          fontSize: '12px',
          width: '70px',
          wordWrap: 'unset',
        }}
      >
        {date.substring(0, 10)}
      </div>
      <div
        style={{
          marginLeft: '33px',
          marginTop: '5px',
          fontSize: '12px',
          width: '70px',
        }}
      >
        {t('nao')}
      </div>
      <div
        style={{
          marginLeft: '69px',
          marginTop: '5px',
          fontSize: '12px',
          width: '52px',
        }}
      >
        {beginTime}
      </div>
      <div
        style={{
          marginLeft: '23px',
          marginTop: '5px',
          fontSize: '12px',
          width: '52px',
        }}
      >
        {endTime}
      </div>
      <div style={{ display: 'flex' }}>
        {!hide?.edit && (
          <Button
            style={{
              border: '0px',
              backgroundColor: 'white',
              padding: '0px',
              marginRight: '5px',
              width: 'fit-content',
            }}
            onClick={onEdit}
            disabled={loading}
          >
            <EditIcon color={loading ? 'grey' : colors.Blue300} />
          </Button>
        )}
        {!hide?.delete && (
          <Button
            style={{
              border: '0px',
              backgroundColor: 'white',
              padding: '0px',
              width: 'fit-content',
            }}
            onClick={onDelete}
            disabled={loading}
          >
            <SmallTrashIcon color={loading ? 'grey' : 'red'} />
          </Button>
        )}
      </div>
    </DamExceptionCardContainer>
  );
}
